<template>
    <div class="Category">
        <div class="Category_inner">
            <div class="Select">
                <el-select v-model="searchInfo.Type" placeholder="请选择类型" size="medium"
                           style="width: 180px;margin-right: 5px" clearable>
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <el-input size="medium" style="width: 180px;margin-right: 5px" v-model="searchInfo.Text"
                          placeholder="请输入内容"></el-input>
                <el-button type="primary" size="medium" @click="getCategoryList">查询
                </el-button>
                <el-button style="float: right" type="primary" size="medium" @click="add">新增</el-button>

            </div>

            <div>
                <el-table :data="CategoryList" style="width: 100%" max-height="520px">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="for" label="类型" align="center" width="200">
                        <template slot-scope="scope">
                            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{scope.row.for}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="text" label="内容" align="center">
                        <template slot-scope="scope">
                            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{scope.row.text}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="listOrder" label="排序" align="center" width="200">
                        <template slot-scope="scope">
                            <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{scope.row.listOrder}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--弹框-->
            <div>
                <el-dialog
                        :title="title" :visible.sync="isShow"
                        width="500px" top="20vh" custom-class="pop-dialog" :before-close="cancel">
                    <el-form :model="formData" label-position="right" label-width="120px" :rules="rules" ref="formData"
                             class="demo-ruleForm" style="width: 100%">

                        <el-form-item label="内容: " prop="title">
                            <el-input size="small" v-model="formData.text"></el-input>
                        </el-form-item>

                        <el-form-item label="选择类型: " style="margin-top: 16px">
                            <el-select
                                    v-model="formData.for"
                                    placeholder="请选择"
                                    size="small"
                                    value-key="id">
                                <el-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                    </el-form>
                    <div style="margin-top: 25px; width: 100%; text-align: center">
                        <el-button
                                @click="cancel"
                                size="small"
                                class="cancel"
                                style="background: rgba(231, 231, 231, 1)"
                        >取消
                        </el-button>
                        <el-button
                                type="primary"
                                @click="onSave"
                                size="small"
                                class="onSave"
                                style="background: rgba(201, 160, 108, 1)"
                        >确 定
                        </el-button>
                    </div>
                    <br/>
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>

    import {GetCategoryList} from '@/assets/js/api'
    import {SaveCategory} from '@/assets/js/api'

    export default {
        name: "Category",
        data() {
            return {
                CategoryList: [],
                options: [
                    {
                        value: 'movie',
                        label: 'movie'
                    },
                    {
                        value: 'music',
                        label: 'music'
                    },
                    {
                        value: '文章',
                        label: '文章'
                    },
                    {
                        value: '家属视频',
                        label: '家属视频'
                    }
                ],
                searchInfo: {
                    Type: '',//类型
                    Text: '',
                },
                pageSizes: [10, 20, 50, 100, 200, 500, 1000],
                total: 0,
                // 弹窗
                isShow: false,
                title: '',
                formData: {
                    for: '',
                    text: '',
                    listOrder: '',
                },
                rules: {
                    Text: [
                        {
                            required: true,
                            message: '请输入内容',
                            trigger: 'change',
                        },
                    ],
                },
            }
        },
        created() {
            this.getCategoryList()
        },
        methods: {
            // 获取数据
            getCategoryList() {

                if (!this.searchInfo.Type) {
                    this.searchInfo.Type = ''
                }
                if (!this.searchInfo.Text) {
                    this.searchInfo.Text = ''
                }

                GetCategoryList(this.searchInfo).then(res => {
                    console.log(res)
                    //if (res.data.ReturnCode == 0) {
                    this.CategoryList = res.data.getcategory
                    // } else {
                    //     this.CategoryList = []
                    // }
                })
            },
            add() {
                this.isShow = true
                this.title = '新增'
            },
            onSave() {
                this.$refs.formData.validate((valid) => {
                    if (!valid) return false

                    console.log(this.formData)
                    SaveCategory(this.formData).then((res) => {
                        console.log('3333333333333333333333'+this.formData.text+'---'+this.formData.for)
                        if (res) {
                            this.$message.success('保存成功')
                            this.cancel()
                        } else {
                            this.$message.success('保存失败')
                        }
                    })

                })
            },
            cancel() {
                this.isShow = false
                this.formData = {
                    For: '',
                    Text: '',
                    ListOrder: '',
                }
                this.resetForm('formData')
            },
            // 查看
            edit(row) {
                this.formData = row;
                this.isShow = true;
                this.title = '详情';
            },


        },
        watch: {
            isShow(to) {
                if (!to) {
                    this.formData = {
                        formData: {
                            Subject: '',
                            message: '',
                        }
                    };
                    this.getCategoryList();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .Category {
        padding: 20px 20px 10px;
        .Category_inner {
            padding: 20px 30px 30px 30px;
            width: calc(100% - 60px);
            min-height: calc(100vh - 155px);
            background: #fff;
            display: flex;
            flex-direction: column;
            font-size: 12px !important;
            .breadcrumb {
                align-items: center;
                justify-content: center;
                .el-breadcrumb {
                    font-size: 15px;
                    line-height: 2;
                }
            }
        }
    }
</style>

<style scoped>
    .Select {
        margin: 10px 0px;
    }
</style>

<style scoped>
    >>> .el-dialog__body {
        padding: 10px 20px;
    }

    >>> .el-form-item {
        margin-bottom: 0px;
    }

    >>> .el-form--label-top .el-form-item__label {
        float: none;
        display: inline-block;
        text-align: left;
        padding: 0;
        line-height: 20px;
    }

    >>> .el-form-item__error {
        padding-top: 0px;
        top: 95%;
        left: auto;
        right: 0;
    }
</style>
